import React from "react";

import { wrap } from "./RydTestbedWrap";
import { GridResolutionDialog } from "../components/pickers/GridResolutionDialog";
import { GridResolution } from "../model/grid";


export function GridResolutionDialogTestbed() {
    const [resolution, setResolution] = React.useState<GridResolution>('1/4 beat');
    const [snap, setSnap] = React.useState<boolean>(true);
    return wrap(<>
        {/* Add your testbed components here */}
        <h1>GridResolutionDialog Testbed</h1>
        <GridResolutionDialog resolution={resolution} setResolution={setResolution} snap={snap} setSnap={setSnap} />
        <p>Selected resolution: {resolution}</p>
        <p>Snap to grid: {snap}</p>
    </>);
}
